<template>
  <div :id="id" style="width: 100%; height: 100%"></div>
</template>

<script>
import { getRegionColorsByValue, getMinMax, colorScheme } from "../assets/util";
export default {
  name: "Map",
  props: {
    data: {
      required: false,
    },
    map: {
      type: Object,
    },
    popup: {
      type: Object,
    },
    indicator: {
      type: String,
    },
    id: {
      type: String,
    },
  },
  watch: {
    isLoaded() {
      this.initMap();
    },
    data() {
      if (this.map.isStyleLoaded() === false) return;
      this.paintRegions();
      this.filterRegions();
    },
  },
  computed: {
    isLoaded() {
      return this.data && this.map ? true : false;
    },
  },
  methods: {
    initMap() {
      const { map } = this;
      map.on("load", () => {
        map
          .setLayoutProperty("country-bubble", "visibility", "visible")
          .setLayoutProperty("country-bubble-label", "visibility", "visible")
          .on("mousemove", "country-shape", this.mousemoveRegion)
          .on("mouseleave", "country-shape", this.mouseleaveRegion)
          .on("mousemove", "country-bubble", this.mousemoveRegion)
          .on("mouseleave", "country-bubble", this.mouseleaveRegion);

        this.paintRegions();
        this.filterRegions();
      });
    },
    paintRegions() {
      const { data, indicator } = this;
      let colors = getRegionColorsByValue(data, indicator);
      let minmax = getMinMax(data);
      this.$emit("handle-minmax", minmax);
      this.map
        .setPaintProperty("country-shape", "fill-color", [
          "interpolate",
          ["exponential", 0.5],
          ["zoom"],
          2.3,
          colors,
          3,
          "#fff",
        ])
        .setPaintProperty("country-bubble", "circle-color", colors);
    },
    filterRegions() {
      let ISO3 = this.data.map((d) => d.ISO3);
      this.map
        .setFilter("country-bubble-label", [
          "match",
          ["get", "ISO3"],
          ISO3,
          true,
          false,
        ])
        .setFilter("country-bubble", [
          "match",
          ["get", "ISO3"],
          ISO3,
          true,
          false,
        ]);
    },
    mousemoveRegion(e) {
      let { ISO3, region } = e.features[0].properties;
      let country = this.data.filter((d) => d.ISO3 === ISO3)[0];
      if (!country) return;
      let result = `
        <div style="font-weight: 600;
          font-size: 1rem;
          font-family: Graphik;">
          <span style="font-weight: 400; font-size: 0.75rem;">${region}</span></br>
          ${country.value.toFixed(2)}&nbsp;${colorScheme[this.indicator].legend}
        </div>
      `;
      this.$emit("handle-value", country.value.toFixed(2));
      this.map.getCanvas().style.cursor = "pointer";
      this.popup
        .setLngLat([e.lngLat.lng, e.lngLat.lat])
        .setHTML(result)
        .addTo(this.map);
    },
    mouseleaveRegion() {
      this.$emit("handle-value", null);
      this.map.getCanvas().style.cursor = "";
      this.popup.remove();
    },
  },
};
</script>

<style>
/* .sdg7-map-container-popup-class {
  font-weight: 600;
  font-size: 1rem;
  font-family: Graphik;
}
.sdg7-map-container-popup-class span {
  font-weight: 400;
  font-size: 0.75rem;
} */
</style>
